import React from 'react'
import Button from '../inputs/button'
import Typography from '../display/typography'

const SSOError = ({ errorSSO, onBackToLogin }) => (
  <div style={{ textAlign: 'center', padding: 20 }}>
    <Typography variant="h6" style={{ marginBottom: 8 }}>
      {errorSSO?.status === 'danger' 
        ? 'Erro de Autenticação SSO'
        : 'Configuração SSO não encontrada'
      }
    </Typography>
    <Typography variant="body2" style={{ marginBottom: 16, color: '#666' }}>
      {errorSSO?.status === 'danger'
        ? 'Não foi possível realizar a autenticação. Entre em contato com o suporte.'
        : 'Não há configuração SSO habilitada para este domínio. Faça login com email e senha.'
      }
    </Typography>
    {errorSSO?.error_code && (
      <Typography variant="caption" style={{ color: '#999', marginBottom: 16, display: 'block' }}>
        Código de erro: {errorSSO.error_code}
      </Typography>
    )}
    <div style={{ display: 'flex', gap: 16, flexDirection: 'column' }}>
      <Button
        size="large"
        variant="outlined"
        color="primary"
        fullWidth={true}
        onClick={onBackToLogin}
      >
        Voltar ao Login
      </Button>
    </div>
  </div>
)

export default SSOError 